export const DEFAULT_STORE_ID = 'demo';
export const SELECTED_MERCHANT_KEY = 'selected_merchant_id';

export function getSelectedMerchantId() {
  if (typeof window === 'undefined') return '';
  const value = String(window.localStorage.getItem(SELECTED_MERCHANT_KEY) || '').trim();
  return value;
}

export function setSelectedMerchantId(merchantId) {
  if (typeof window === 'undefined') return;
  const value = String(merchantId || '').trim();
  if (!value || value === DEFAULT_STORE_ID) {
    window.localStorage.removeItem(SELECTED_MERCHANT_KEY);
    return;
  }
  window.localStorage.setItem(SELECTED_MERCHANT_KEY, value);
}

export function clearSelectedMerchantId() {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(SELECTED_MERCHANT_KEY);
}

/**
 * Normalizes merchant ID for path parameters
 */
export function normalizeStoreId(merchantId) {
  const value = (merchantId || '').trim();
  return value || DEFAULT_STORE_ID;
}

/**
 * NEW: Generates the context-aware entry URL (for QR codes)
 * e.g., /store?merchant_id=123
 */
export function storeEntryRoute(merchantId) {
  if (!merchantId || merchantId === 'demo') return '/store';
  return `/store?merchant_id=${merchantId}`;
}

/**
 * Generates the deep-linked path inside a restaurant context
 * e.g., /store/123/wallet
 */
export function storeRoute(merchantId, subPath = '') {
  const base = `/store/${normalizeStoreId(merchantId)}`;
  const suffix = (subPath || '').trim().replace(/^\/+/, '');
  return suffix ? `${base}/${suffix}` : base;
}
